<app-side-dialog [disableClose]="true" (closeDialog)="onCloseClick()">
  <div dialogHeader>
    <h2>{{ 'pages.settings.userManagement.users.inviteUserDialog.title' | translate }}</h2>
  </div>

  <div dialogContent class="flex flex-col">
    <form [formGroup]="form" class="flex flex-col gap-3 custom-form" (ngSubmit)="onSubmit()">
      <mat-form-field class="w-full">
        <input
          matInput
          formControlName="email"
          [placeholder]="'pages.settings.userManagement.users.inviteUserDialog.emailPlaceholder' | translate"
        />
        <mat-error [control]="form.get('email')" />
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-select
          formControlName="role"
          [hideSingleSelectionIndicator]="true"
          [placeholder]="'pages.settings.userManagement.users.inviteUserDialog.rolePlaceholder' | translate"
        >
          @for (role of assignableRoles(); track role.id) {
            <mat-option [value]="role.id">{{ getRoleName(role) }}</mat-option>
          }
        </mat-select>
        <mat-error [control]="form.get('role')" />
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-select
          formControlName="team"
          [hideSingleSelectionIndicator]="true"
          [placeholder]="'pages.settings.userManagement.users.inviteUserDialog.teamPlaceholder' | translate"
        >
          <mat-select-trigger>
            @if (form.controls.team.value) {
              {{ getSelectedTeamName() }}
            } @else {
              <span class="text-sm text-shikenso-purple-base-60">
                {{ 'pages.settings.userManagement.users.inviteUserDialog.teamPlaceholder' | translate }}
              </span>
            }
          </mat-select-trigger>

          @for (team of data.teams; track team.id) {
            <mat-option [value]="team.id">{{ team.name }}</mat-option>
          }
        </mat-select>

        @if (form.controls.team.value) {
          <button
            matSuffix
            mat-icon-button
            type="button"
            class="mat-secondary-transparent-button-color"
            (click)="$event.stopPropagation(); form.controls.team.setValue(null)"
          >
            <app-icon src="/icons/close.svg" alt="Clear" [size]="14" />
          </button>
        }
      </mat-form-field>

      <mat-form-field class="flex-1 expandable-textarea-field">
        <textarea
          matInput
          cdkTextareaAutosize
          class="!flex !items-center"
          formControlName="message"
          cdkAutosizeMinRows="3"
          cdkAutosizeMaxRows="10"
          [placeholder]="'pages.settings.userManagement.users.inviteUserDialog.messagePlaceholder' | translate"
        ></textarea>
        <mat-error [control]="form.get('message')" />
      </mat-form-field>

      <div class="flex justify-end gap-3 mt-6">
        <button mat-button type="button" [disabled]="store.sendInvitationLoading$()" (click)="onCloseClick()">
          {{ 'shared.cancel' | translate }}
        </button>

        <button mat-flat-button color="primary" type="submit" [disabled]="store.sendInvitationLoading$()">
          <p [class.hidden]="store.sendInvitationLoading$()">
            {{ 'pages.settings.userManagement.users.inviteUserDialog.sendInvite' | translate }}
          </p>

          @if (store.sendInvitationLoading$()) {
            <app-dots-spinner />
          }
        </button>
      </div>
    </form>
  </div>
</app-side-dialog>
